<template>
	<div>
		<NuxtLayout>
			<div class="m-4 text-3xl text-center panel dark:text-white">
				{{ error?.statusCode }} Error: {{ error?.statusMessage }}
			</div>
		</NuxtLayout>
	</div>
</template>

<script setup lang="ts">
import { useErrorReporter } from '@/composables/useErrorReporter'
import { accountDirectory } from '@/constants/portalNames.js'
import { setIsAccountPortal } from './composables/useIsAccountPortal'

const error = useError()

// NOTE: this is a bit stupid.  I think the whole bit that i made aroudn this can be refactored to make a lot more sense.  but this gets 404s to show the right nav
try {
	if (window?.location?.host?.indexOf(accountDirectory) >= 0) {
		setIsAccountPortal(accountDirectory)
	}
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
} catch (e) {
	// console.log(e)
}

watchEffect(() => {
	if (error.value) {
		const { bugsnagReport } = useErrorReporter()
		bugsnagReport({
			error: new Error(error.value?.statusMessage),
			metaData: {
				statusCode: error.value.statusCode,
				message: error.value.statusMessage,
				unhandled: error.value.unhandled
			}
		})
	}
})
</script>
